import * as React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"

import { Container, Navbar, Nav } from 'react-bootstrap'

import logo from "../images/ECI_logo_uppercase.svg"

const Header = ({ siteTitle }) => (
  <nav>
    <Container>
    <Navbar className="navbar-light" id="mainNav" expand="lg"
                collapseOnSelect={true}>
          
            <Link className="navbar-brand" to="/">
              <img src={logo} alt={siteTitle} className="logo" width="250" />
            </Link>
            <Navbar.Toggle aria-controls="navbarResponsive"/>
            <Navbar.Collapse id="navbarResponsive">
              <Nav className="navbar-nav text-center ml-auto" >
              <ul className="navbar-nav  text-center">

                <li><Link to="/about/" className="nav-link" activeClassName="active">About Us</Link></li>
            
                <li><Link to="/services/" partiallyActive={true} className="nav-link" activeClassName="active">Our Services</Link></li>

                <li><Link to="/eci-process/" className="nav-link" activeClassName="active">ECI Process</Link></li>
             
            
                <li><Link to="/contact/" className="nav-link" activeClassName="active">Contact Us</Link></li>
              </ul>
              </Nav>
            </Navbar.Collapse>
        </Navbar>
    </Container>
    
    
  </nav>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
